import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { IMediaResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { Media } from "@/models"

interface UseGetWelcomeVideoOptions {
  enabled?: MaybeRef<boolean>
}

// TODO: refactor this into listMedia api function, just need to allow for eventVidType param
export async function getWelcomeVideo(eventVaultId?: number, albumId?: number): Promise<Media[]> {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to query media. Please ensure `eventVaultId` is provided.")
  }

  const endpoint = albumId ? `api/guest/${eventVaultId}/album/${albumId}/media` : `api/guest/${eventVaultId}/media`

  const eventVidType = 3

  const response = await axios.get<ServerResponse<IMediaResponse[]>>(`${endpoint}`, { params: { eventVidType } })

  return response.data.Data?.map(media => Media.fromResponse(media)) ?? []
}

const GET_WELCOME_VIDEO_KEY = "getWelcomeVideo"

export function useGetWelcomeVideo(eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>, options: UseGetWelcomeVideoOptions = {}) {
  const { enabled } = options

  return useQuery({
    queryKey: [GET_WELCOME_VIDEO_KEY, eventVaultId, albumId],
    queryFn: () => getWelcomeVideo(toValue(eventVaultId), toValue(albumId)),
    enabled: !!toValue(eventVaultId) && enabled,
  })
}
